import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class InvoiceService {
  constructor(private http: HttpClient) {}

  createInvoice(payload: any) {
    return this.http.post(`${environment.apiUrl}/invoice/create`, payload);
  }

  getPagedInvoices(payload: {
    pageIndex: number;
    pageSize: number;
    filters: any;
    sortField?: string;
    sortOrder?: number;
  }) {
    const requestPayload = {
      ...payload,
    };
    return this.http.post(
      `${environment.apiUrl}/invoice/get-paged`,requestPayload
    );
  }

  getOneInvoiceById(id: string) {
    return this.http.get(`${environment.apiUrl}/invoice/get-one/${id}`);
  }

  updateInvoice(payload: any) {
    return this.http.put(`${environment.apiUrl}/invoice/update`, payload);
  }
}
